import { IoSaveOutline } from 'react-icons/io5'
import { vccBtn } from '@shared/ui/vccButtons'
import { vccButtonLabel, type VccActionButtonProps } from './vccButtonProps'

export type SaveButtonProps = VccActionButtonProps & {
  type?: 'button' | 'submit'
}

export default function SaveButton({
  onClick,
  disabled,
  type = 'submit',
  className = '',
  showIcon = true,
  loading = false,
  loadingLabel = 'Saving...',
  label = 'Save',
  children,
  ...rest
}: SaveButtonProps) {
  return (
    <button
      type={type}
      className={`${vccBtn('save')} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled || loading}
      {...rest}
    >
      {showIcon && !loading && <IoSaveOutline aria-hidden className="vcc-btn__icon" />}
      {vccButtonLabel({ children, label, loading, loadingLabel }, label)}
    </button>
  )
}
